








import Vue from "vue";
const defaultLayout = "default";

export default Vue.extend({
  computed: {
    layout(): string {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    }
  },
  created() {
    this.$store.dispatch("weather/fetch");
    // nothing defined here (when this.$route.path is other than "/")
    console.log(this.$route, this.$route.meta.layout);
  },

  updated() {
    // something defined here whatever the this.$route.path
    console.log(this.$route, this.$route.meta.layout);
  }
});
